module.exports = __webpack_public_path__ + "toggle-toolbar.svg?4e85a31a6b27ac57725e07520c0a1d8e";